// The product's own name, in ONE place.
//
// Not in lib/brand.ts — that module models a MENTOR's personal brand (their coaching-centre
// name/logo), which is a different thing that happens to share the word.
//
// The 2026 rename from "Mentor Guru Search" to "Shrey Aadi Mentor Hub" was done by editing
// each hardcoded occurrence, and it missed a homepage FAQ line and the bottom CTA button —
// both live for weeks. Anything user-facing should read from here.
//
// DELIBERATELY OUT OF SCOPE: /terms and /privacy still say "Mentor Guru Search". Those are
// executed legal documents naming the operating entity's brand; changing them is a legal
// decision, not a string cleanup. Leave them to the lawyers.
export const SITE_NAME = 'Shrey Aadi Mentor Hub';

/** Contact address published to users. Kept identical to the one in /terms and /privacy. */
export const CONTACT_EMAIL = 'hello@shreyaadieducation.in';
